import { Component, ElementRef, ViewChild, HostListener } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { catchError, map, merge, startWith, Subject, switchMap, takeUntil, of as observableOf, last } from 'rxjs';
import { UsersService } from 'src/app/private/services/users.service';
import { WhatsappTemplateService } from 'src/app/private/services/whatsapp-tempate.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { Router } from '@angular/router';
import { ContactGrouopService } from 'src/app/private/services/contact-groups.service';
import { ContactGroupListComponent } from '../../components/contact-group-list/contact-group-list.component';

import { ViewEncapsulation } from '@angular/core';
import { EmailEditorComponent } from 'angular-email-editor';
import { EmailTemplateService } from 'src/app/private/services/email-tempate.service';
import { SequenceService } from 'src/app/private/services/sequence.service';


import { EventEmitter, Input, Output } from '@angular/core';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { EmailHubService } from 'src/app/private/services/email-hub.service';
import { LeadService } from 'src/app/private/services/lead.service';
import { ActivatedRoute } from '@angular/router';
import { TrackingService } from 'src/app/private/services/tracking.service';

import * as moment from 'moment-timezone';

@Component({
  selector: 'app-sequence-detail',
  templateUrl: './sequence-detail.component.html',
  styleUrls: ['./sequence-detail.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class SequenceDetailComponent {
  mobileSequenceFilter: boolean = false;
  private contactModalRef: NgbModalRef | null = null;
  dataSource: MatTableDataSource<any> = new MatTableDataSource();
  contactdataSource: MatTableDataSource<any> = new MatTableDataSource();
  @ViewChild(ContactGroupListComponent) contactGroupListComponent!: ContactGroupListComponent;
  totalRows = 0;
  safeUrl = "";
  currentPage = 0;
  pageSize = 10;
  pageSizeOptions: number[] = [10, 25, 100];
  @ViewChild(MatPaginator)
  paginator!: MatPaginator;
  @ViewChild(MatSort)
  sort!: MatSort;
  searchQuery = new FormControl();
  dateQuery = new FormControl();
  btnLoading = false;
  templateIDtoDelete: any;
  template: any;
  currentTime!: string;
  timerId: any;
  processedData: SafeHtml = '';
  quickReplyButtons: any[] = [];
  urlButtons: any[] = [];
  callButtons: any[] = [];
  countQuickReplyButton = 0;
  countCTAButtonForURL = 0;
  templateToEdit: any;
  initialLoad = true;
  templateToDelete: any;
  renderedData: any;
  header: any;
  footer: any;
  templateType: any;
  mediaId: any;
  isRefresh = false;
  title_top: any = "";
  title_name: any = "";
  showAllVariables = false;
  selectedTemplateForRejection: any;
  active: any = 0;
  paused: any = 0;
  not_sent: any = 0;
  delivered: any = 0;
  sent: any = 0;
  opened: any = 0;
  contact_Group = "";
  displayedColumns: string[] = [
    "Template"
  ];

  contactdisplayedColumns: string[] = [
    "sno",
    "name",
    "source",
    "email"
  ];

  emaildisplayedColumns: string[] = [
    "to",
    "seqName",
    "taskName",
    "status",
    "date"
  ];

  initialLoad2 = true;
  contactGroups: any = {};
  GroupListData: any;
  currentSelectedContactGroupID: any;
  private destroy$ = new Subject<void>();
  user: Sequence = new Sequence();
  isLoading = false;

  @Input() type: any;
  @Input() templateDataToEdit: any;
  title = 'angular-email-editor';
  pageTitle = 'Create';

  htmlData = '';
  design = '';
  options = {
    // setting previw to mobile

  }

  formData = {
    templateName: '',
    templateCategory: '',
    status: ''
  };

  stepName = "";
  dynamicFields = ['firstName', 'lastName', 'email'];
  editorLoadedFlag = false;
  allLeadFeilds: any = [];
  signatures: any = [];

  taskType: any;
  automaticTask: any;

  dataLoading = false;
  isSignatureDraging = false;
  scheduledTime: any;
  scheduledDate: any;

  minDate: string = new Date().toISOString().split('T')[0];

  previousScheduledDate: any;
  previousScheduledTime: any;

  @ViewChild(EmailEditorComponent)
  private emailEditor!: EmailEditorComponent;

  @Output() close: EventEmitter<any> = new EventEmitter();
  @Output() reload: EventEmitter<any> = new EventEmitter();

  files: any[] = [];
  // public Editor = ClassicEditor as unknown as any;

  @Input() communicationData: any;
  templateSelection: string = 'custom'; // Default to custom template
  // editorData: string = ''; // CKEditor data
  selectedTemplate: string | null = null;
  templates: any[] = [];
  emailSubject: string = '';
  isFetchingTemplates = false;
  sanitizedData: SafeHtml = '';
  btnLoading2 = false;
  notes: string = '';
  btnLoading3 = false;
  emails: string[] = [];
  templateDataToSend: any = {};
  currentSingature: any = '';
  sequence_id = "";

  @ViewChild('Content1') content1: any;

  userData: any = {
    contact_name: 'Gaurav',
    contact_phone: '123-456-7890',
    company_name: 'YourCompany'
  };

  new_stepName = "";
  new_subject = "";
  new_editorData: any;
  taskToEdit: any;
  time_type = "";
  time_unit: any;
  schedule_immediately = false;
  new_schedule_date = "";
  new_schedule_time = "";
  new_automatic_schedule = false;
  isShowImmediatelyOnEdit = false;

  immediat_option = "";
  when_option = "";
  new_task = true;

  tab1Loaded = false;
  tab2Loaded = false;

  deleteLoading = false;

  public Editor = ClassicEditor as unknown as any;
  editorData: string = ''; // CKEditor data
  public editorInstance: any;
  public variables = ['{{name}}', '{{phone}}', '{{email}}'];

  isAdmin: boolean = false;

  constructor(
    private router: Router,
    private toast: ToastrService,
    private api: WhatsappTemplateService,
    private api2: EmailTemplateService,
    private api3: LeadService,
    private api4: EmailHubService,
    private modalService: NgbModal,
    private LocalStorage: LocalStorageService,
    private userApi: UsersService,
    private sanitizer: DomSanitizer,
    private contactApi: ContactGrouopService,
    private sequenceApi: SequenceService,
    private route: ActivatedRoute,
    private tracker: TrackingService,
    private localStorageService: LocalStorageService

  ) {
    this.title_name = localStorage.getItem('sequence_name')
    this.title_top = "Sequence : " + localStorage.getItem('sequence_name')

    this.isAdmin = this.localStorageService.checkFullAccessForTableList(
      this.localStorageService.getRole()
    );

  }

  dayNames: string[] = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

  data: any = {};

  currentSequence: any;

  ngOnInit() {
    this.updateTime();
    this.timerId = setInterval(() => this.updateTime(), 60000); // Update every minute

    this.currentSequence = JSON.parse(localStorage.getItem('sequence_selected') || "");
    this.paused = this.currentSequence.paused;
    this.active = this.currentSequence.active;
    this.not_sent = this.currentSequence.bounce;
    this.sent = this.currentSequence.send;
    this.delivered = this.currentSequence.delivery;
    this.opened = this.currentSequence.open;

    this.sequence_id = this.route.snapshot.paramMap.get('id')!;
    console.log("seq_id : ", this.sequence_id);
    let signature = this.LocalStorage.getSignatures();
    signature.forEach((element: any) => {
      if (element.isActive === true || element.isActive === 'true') {
        this.currentSingature = element.signature;
        this.editorData = `<br><br><br><br>${this.currentSingature}`
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  updateTime() {
    const now = new Date();
    const hours = now.getHours();
    const minutes = now.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    const formattedHours = hours % 12 || 12; // Convert 24-hour to 12-hour format
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

    this.currentTime = `${formattedHours}:${formattedMinutes} ${ampm}`;
  }

  ngAfterViewInit() {
    // this.tab1Loaded = true;
    this.taskType = "manual";

    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    this.sort.sortChange.subscribe(() => {
      // safe now
    });
    this.loadData();

  }

  activateSequenceTask(event: any, element: any) {
    // console.log("element slide : ",element);
    // if(element.status == true) {
    console.log("enabled : ", this.active, this.paused)
    // }
    this.currentSequence = JSON.parse(localStorage.getItem('sequence_selected') || "");
    this.data = JSON.parse(localStorage.getItem('sequence_selected') || "");
    if (this.currentSequence.contact_group == null || this.currentSequence.contact_group == "") {
      this.toast.error('Please add contact before activating this task !');
      element.status = false;
      this.dataSource.data = JSON.parse(JSON.stringify(this.dataSource.data));
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      return;
    }
    let param = {
      id: element.id,
      client_id: this.LocalStorage.getClientId(),
      sequence_id: this.route.snapshot.paramMap.get('id')!,
      status: element.status
    }
    console.log("element slide2 : ", param);
    this.sequenceApi.updateSequenceTask(param).subscribe({
      next: (res: any) => {
        console.log("roles :", res);
        let param2: any = {
          id: element.sequence_id,
          client_id: this.LocalStorage.getClientId(),
        }
        if (element.status == true) {
          param2.action = 'increment';
        }
        if (element.status == false) {
          param2.action = 'decrement';
        }
        console.log("element slide2 : ", param2);
        // this.sequenceApi.updateSequenceCounter(param2).subscribe({
        //   next: (res: any) => {
        //     this.tracker.track(
        //       element.status ? 'Activate' : 'Deactivate',
        //       'Sequence Task',
        //       `Task ${element.name} ${element.status ? 'activated' : 'deactivated'} in sequence ${this.title_name}`
        //     );

        //     console.log("updated roles :", res);
        //     // localStorage.setItem('sequence_selected', JSON.stringify(res));
        //     this.currentSequence = JSON.parse(localStorage.getItem('sequence_selected') || "");
        //     this.paused = this.currentSequence.paused;
        //     this.active = this.currentSequence.active;
        //   }
        // })
      }
    })
  }


  onReady(editor: any): void {
    this.editorInstance = editor;
  }

  insertVariable(variable: any): void {
    // Check if the selected value is not null or empty
    if (variable.target.value && this.editorInstance) {
      const viewFragment = this.editorInstance.data.processor.toView(variable.target.value);
      const modelFragment = this.editorInstance.data.toModel(viewFragment);

      this.editorInstance.model.insertContent(modelFragment);
    }
  }


  onTabChange(event: any) {
    console.log("tabb : ", event.index)
    switch (event.index) {
      case 0:
        if (!this.tab1Loaded) this.loadData();
        break;
      case 1:
        if (!this.tab2Loaded) this.loadContacts(); this.getContactGroup()
        break;
    }
  }

  loadData() {
    this.initialLoad = true;
    try {
      this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));
      merge(this.searchQuery.valueChanges, this.sort.sortChange, this.paginator.page).pipe(startWith({}),
        switchMap(() => {
          let param = {
            where: {
              sequence_id: this.sequence_id,
              client_id: parseInt(this.LocalStorage.getClientId())
            },
            // page: (this.paginator.pageIndex * this.paginator.pageSize),
            // limit: this.paginator.pageSize,
            filter: this.searchQuery.value,
            order: [{ col: 'createdAt', dir: "asc" }],
          }
          return this.sequenceApi.getAllSequenceTaskWithCount(param)
            .pipe(catchError(() => observableOf(null)));
        }), map((response: any) => {
          if (response === null) {
            this.initialLoad = false;
            return [];
          }

          this.totalRows = response.count;
          return response
        })
      ).subscribe({
        next: (data) => {
          this.initialLoad = false;
          this.tab1Loaded = true;
          console.log("Data->rows", data.rows)
          this.dataSource = new MatTableDataSource<any>(data.rows);
          console.log("data sorccccc : ", this.dataSource.data);
          this.currentSequence = JSON.parse(localStorage.getItem('sequence_selected') || "");
          this.paused = this.currentSequence.paused;
          this.active = this.currentSequence.active;
          this.not_sent = this.currentSequence.bounce;
          this.sent = this.currentSequence.send;
          this.delivered = this.currentSequence.delivery;
          this.opened = this.currentSequence.open;
          this.currentSelectedContactGroupID = this.currentSequence.contact_group;
          this.loadEmailTemplate()
        },
        error: (e) => {
          console.error(e)
        },
        complete: () => {
          this.initialLoad = false;
        }
      })
    }
    catch (e) {
      this.isLoading = false;
      console.error(e)
    }
  }

  handleRefresh() {
    this.loadData();
  }

  handleUpdateData(type?: string) {

    if (type === 'refresh') {
      this.isRefresh = true;
    }

    try {
      let param = {
        client_id: this.LocalStorage.getClientId(),
        pageNo: this.paginator.pageIndex + 1,
        pageSize: this.paginator.pageSize,
      };

      this.api.getAllTemplate(param).subscribe({
        next: (response: any) => {
          if (response) {
            this.totalRows = response.totalCount;
            this.dataSource = new MatTableDataSource<any>(response.templates);

            this.tracker.track(
              'Load',
              'Email Template',
              `Fetched ${response.templates.length} templates for sequence ${this.title_name}`
            );


            if (type === 'update') {
              this.modalService.dismissAll();
              this.toast.success('Template updated successfully');
            }

            if (type === 'create') {
              this.modalService.dismissAll();
              this.toast.success('Template created successfully');
            }

            if (type === 'delete') {
              this.modalService.dismissAll();
              this.toast.success('Template deleted successfully');
            }

            if (this.isRefresh) {
              this.isRefresh = false;
            }

            this.btnLoading = false;

          } else {
            this.toast.warning('No templates found.');
          }
        },
        error: (error: any) => {
          console.error('Error fetching templates:', error);
          this.toast.error('Failed to update templates. Please try again later.');
        },
        complete: () => {
          console.log('Template fetching completed.');
        }
      });
    } catch (e) {
      console.error('Unexpected error:', e);
      this.toast.error('An unexpected error occurred.');
    }
  }


  closeModal() {
    this.close.emit();
    this.modalService.dismissAll();
  }


  open(content: any) {
    if (this.currentSequence.active == null || this.currentSequence.paused == null) {
      this.immediat_option = "immediately upon task activation";
      this.when_option = "after the task activation";
    }
    else {
      this.immediat_option = "immediately after previous task";
      this.when_option = "after the previous task";
      this.new_task = false;
    }
    this.modalService.open(content, { size: 'ml', scrollable: true, centered: true })
  }

  openContact(content: any) {
    this.getContactGroup();
    setTimeout(() => { }, 1000);
    this.contactModalRef = this.modalService.open(content, { size: 'ml', scrollable: true, centered: true })
  }

  getEmailBodyContent(content: any) {
    if (typeof content === 'string') {
      return content.trim() || '';
    }
    return Object.keys(content || {}).length > 0 ? content : '';
  }

  handleDeleteEvent() {

    this.btnLoading = true;
    const payload = {
      client_id: this.LocalStorage.getClientId(),
      elementName: this.templateToDelete.elementName,
      template_id: this.templateToDelete.id
    }

    this.api.deleteTemplate(payload).subscribe(
      (response: any) => {
        if (response) {
          this.tracker.track(
            'Delete',
            'Email Template',
            `Deleted template: ${this.templateToDelete?.elementName || this.templateToDelete?.id}`
          );

          this.handleUpdateData('delete');
        }
      },
      (error: any) => {
        this.toast.error("Error occurred while deleting template");
      }
    );

  }

  handleOpenDeleteTemplateDialog(content: any, element: any) {
    this.modalService
      .open(content, { size: 'md', centered: true })

    this.templateToDelete = element;
  }

  handleOpenPreviewDialog(content: any, template: any) {
    this.templateType = template.templateType;

    if (template.templateType === 'IMAGE' || template.templateType === 'VIDEO' || template.templateType === 'DOCUMENT' || template.templateType === 'GIF') {
      const data = JSON.parse(template.meta);
      this.mediaId = data.mediaId;
    }
    const { header, body, footer } = this.splitString(template.containerMeta);
    this.header = header;
    this.footer = footer;
    const { quickReplyButtons, urlButtons, callButtons } = this.parseButtons(template.containerMeta);

    this.quickReplyButtons = quickReplyButtons.map((button: string) => ({ value: button }));

    this.urlButtons = urlButtons.map((button: any) => ({ title: button.text, urlType: button.urlType, value: button.url }));

    this.callButtons = callButtons.map((button: any) => ({ title: button.text, value: button.url }));

    this.countQuickReplyButton = this.quickReplyButtons.length;

    this.countCTAButtonForURL = this.urlButtons.length;

    this.renderedData = this.formateData(body);

    this.modalService.open(content, { windowClass: 'custom-modal-class', centered: true });
  }

  handleOpenRejectedReasonDialog(content: any, template: any) {
    this.selectedTemplateForRejection = template;
    this.modalService.open(content, { centered: true, size: 'md' });
  }

  formateData(data: any) {
    return data
      .replace(/\n/g, '<br>') // Replace \n with <br>
      .replace(/\*(.*?)\*/g, '<b>$1</b>'); // Replace *text* with <b>text</b>
  }

  splitString(inputString: any) {

    // Parse the input string as JSON
    const inputData = JSON.parse(inputString);

    // Extract the header, body (data), and footer from the JSON object
    const { header, data: body, sampleText, footer } = inputData;

    return {
      header: header,
      body: this.updateSampleText(sampleText),
      footer: footer
    };
  }

  updateSampleText(input: string): string {
    return input.replace(/\[(.*?)\]/g, '$1');
  }


  formatMessage(message: string): string {
    if (typeof message !== 'string') {
      // Return empty string if message is not a string or is null/undefined
      return '';
    }

    message = message.split('|')[0].trim();
    return message
      .replace(/\n/g, '<br>') // Replace \n with <br>
      .replace(/\*(.*?)\*/g, '<b>$1</b>'); // Replace *text* with <b>text</b>
  }
  formatMessage2(message: string): string {
    if (typeof message !== 'string') {
      // Return empty string if message is not a string or is null/undefined
      return '';
    }

    message = message.split('|')[0].trim();
    return message
      .replace(/\n/g, '') // Replace \n with <br>
      .replace(/\*(.*?)\*/g, '<b>$1</b>'); // Replace *text* with <b>text</b>
  }

  showAllOptions() {
    this.showAllVariables = !this.showAllVariables;
  }

  parseButtons(input: string): {
    quickReplyButtons: string[], urlButtons: { text: string, urlType: string, url: string }[],
    callButtons: { text: string, url: string }[]
  } {
    const quickReplyButtons: string[] = [];
    const urlButtons: { text: string, urlType: string, url: string }[] = [];
    const callButtons: { text: string, url: string }[] = [];

    // Parse the input string as JSON
    const inputData = JSON.parse(input);

    // Assuming buttons field is present in the input JSON
    const { buttons } = inputData;


    if (buttons) {
      buttons.forEach((button: any) => {
        if (button.type === 'QUICK_REPLY') {
          // Add to quickReplyButtons if type is QUICK_REPLY
          quickReplyButtons.push(button.text.trim());
        } else if (button.type === 'URL') {
          // Add to urlButtons if type is URL
          urlButtons.push({ text: button.text.trim(), urlType: "static", url: button.url.trim() });
        } else if (button.type === 'PHONE_NUMBER') {
          // Add to urlButtons if type is URL
          callButtons.push({ text: button.text, url: button.phone_number });
        }
      });
    }

    return { quickReplyButtons, urlButtons, callButtons };
  }

  editTask(content: any, template: any) {
    console.log("template to edit : ", template);
    this.taskToEdit = template;
    this.new_stepName = template.name;
    this.new_subject = template.email_template.subject;
    this.new_schedule_date = template.automatic_schedule ? null : template.schedule_date || ''; // or use another value if different
    this.new_schedule_time = template.automatic_schedule ? null : template.schedule_time || ''; // or use another value if different
    this.new_automatic_schedule = template.automatic_schedule || false;
    this.isShowImmediatelyOnEdit = this.new_automatic_schedule;
    this.templateSelection = template.email_template.type;
    this.selectedTemplate = template.email_template.temp_id;

    this.editorData = template.email_template.bodyContent;
    this.modalService.open(content, {
      size: 'xl',
      scrollable: true,
      centered: true
    });
    this.tracker.track(
      'Edit',
      'Sequence Task',
      `Editing task ${template.name} in sequence ${this.title_name}`
    );

  }

  backto() {
    this.router.navigate(['/main/sequences']);
  }

  goToContact() {
    this.contactModalRef?.close();
    this.router.navigate(['/main/contact-groups']);
  }

  getContactGroup() {
    let param: any = {
      "where": {
        "client_id": this.LocalStorage.getClientId()
      },
      "order": {
        "col": "\"contact_group\".\"updatedAt\"",
        "dir": "DESC"
      }
    }

    if (!this.isAdmin) {
      param.where.user_id = this.LocalStorage.getUserId();
    }

    // if(this.dateQuery.value){param = {...param,...this.dateQuery.value}}
    this.contactApi.getAllContactGroups(param).subscribe({
      next: (res: any) => {
        console.log("campaignList data :", res);
        this.contactGroups = res || {};
      },
      error(err) {
        console.log("err : ", err);
      },
    })
  }

  loadContacts(type?: string) {
    this.initialLoad2 = true;
    try {
      console.log("group : ", this.currentSelectedContactGroupID)
      // this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));
      if (this.currentSelectedContactGroupID) {
        merge(
        )
          .pipe(
            startWith({}),
            switchMap(() => {
              console.log("client_id", this.LocalStorage.getClientId())
              const payload = {
                "where": {
                  "client_id": this.LocalStorage.getClientId(),
                  "contact_group_id": this.currentSelectedContactGroupID
                },
                "filter": null,
                "page": this.currentPage * this.pageSize,
                "limit": this.pageSize,
                "order": {
                  "col": "\"contact_group_list\".\"updatedAt\"",
                  "dir": "DESC"
                }
              }


              return this.contactApi
                .getAllContactGroupList(payload)
                .pipe(catchError(() => observableOf(null)));
            }),
            map((response: any) => {
              if (response === null) {
                return [];
              }
              this.totalRows = response.count;
              this.isRefresh = false;
              return response.rows;
            })
          )
          .subscribe({
            next: (data) => {
              this.initialLoad2 = false;
              this.tab2Loaded = true;
              this.contactdataSource = new MatTableDataSource<any>(data);
              this.GroupListData = data;

              if (type === 'Create') {


                this.modalService.dismissAll();
                this.btnLoading = false;
              }
            },
            error: (e) => {
              this.initialLoad2 = false;
              console.error(e);
            },
            complete: () => {
            },
          });
      }
      else {
        this.initialLoad2 = false;
        this.contactdataSource = new MatTableDataSource();
      }
    } catch (e) {
      console.error(e);
    }
  }

  saveSequence() {

  }

  addContactGroup() {
    if (this.contact_Group) {
      this.isLoading = true;
      let param = {
        id: this.currentSequence.id,
        client_id: this.LocalStorage.getClientId(),
        contact_group: this.contact_Group
      }
      console.log("element slide2 : ", param);
      this.sequenceApi.updateSequence(param).subscribe({
        next: (res: any) => {
          console.log("roles :", res);
          this.isLoading = false;
          localStorage.setItem('sequence_selected', JSON.stringify(res));

          this.tracker.track(
            'Update',
            'Sequence Contact Group',
            `Added contact group (ID: ${this.contact_Group}) to sequence ${this.title_name}`
          );

          this.contactModalRef?.close();
          this.currentSelectedContactGroupID = this.contact_Group;
          this.loadContacts();
        }
      })
    }
  }


  getLeadsFields() {
    // id = this.localStorage.getClientId()
    let param = {
      client_id: this.LocalStorage.getClientId(),
    };
    this.dataLoading = true;

    this.allLeadFeilds.push({ key: 'Cotact Name', value: 'contact_name' });
    this.allLeadFeilds.push({ key: 'Contact Email', value: 'contact_email' });
    this.allLeadFeilds.push({ key: 'Contact Phone', value: 'contact_phone' });
    this.allLeadFeilds.push({ key: 'Company Name', value: 'company_name' });
    this.allLeadFeilds.push({ key: 'Lead Source', value: 'lead_source' });


    this.api3.getLeadsFields(param).subscribe({
      next: (data) => {
        this.dataLoading = false;

        const newFiled = data.fields?.map((element: any) => {
          return {
            key: element.label,
            value: element.field_name
          }
        }
        );

        this.allLeadFeilds = [...this.allLeadFeilds, ...newFiled];


      },
      error: (e: any) => {
        this.dataLoading = false;
        console.error(e);
      },
    });
  }


  onDragStart(event: DragEvent, field: string) {
    console.log('Drag start event:', event);
    // Store the field value in the dataTransfer object
    event.dataTransfer?.setData('text', field);
    this.editorLoadedFlag = true;
  }

  onDragStart2(event: DragEvent, field: string) {
    console.log('Drag start event:', event);
    // Store the field value in the dataTransfer object
    event.dataTransfer?.setData('text', field);
    this.editorLoadedFlag = true;
    this.isSignatureDraging = true;
  }

  // This method allows the drop by preventing the default behavior
  onDragOver(event: DragEvent) {
    console.log('Drag over event:', event);
    event.preventDefault();

  }

  onDragEnd(event: DragEvent) {
    console.log('Drag end event:', event);
    event.preventDefault();
    this.editorLoadedFlag = false;
  }


  onDragEnd2(event: DragEvent) {
    console.log('Drag end event:', event);
    event.preventDefault();
    this.editorLoadedFlag = false;
    this.isSignatureDraging = false;
  }

  // This method handles the drop and calls insertPlaceholder
  onDrop(event: DragEvent) {
    console.log('Drop event:', event);
    event.preventDefault();
    const field = event.dataTransfer?.getData('text'); // Retrieve the dragged field
    this.editorLoadedFlag = false;
    if (field) {
      this.insertPlaceholder(field); // Call the method to insert the placeholder
    }
  }

  insertPlaceholder(field: string) {
    let placeholder = '';
    if (this.isSignatureDraging) {
      placeholder = `${field}`;
    } else {
      placeholder = `{{${field}}}`;
    }

    this.emailEditor.editor.exportHtml((data: any) => {
      const design = data.design;

      // Ensure the `rows` array exists in the design body
      if (!design.body.rows) {
        design.body.rows = [];
      }

      if (design.body.rows.length === 0) {
        // If no rows exist, add a new row
        const newRow = {
          id: `row_${Date.now()}`, // Generate a unique ID for the row
          cells: [1], // Define the cell count
          columns: [
            {
              id: `col_${Date.now()}`, // Generate a unique ID for the column
              contents: [
                {
                  type: 'text', // Text content type
                  values: {
                    text: `<span>${placeholder}</span>`, // The placeholder text wrapped in <p>
                  }
                }
              ],
              values: {
                backgroundColor: "",
                padding: "0px",
                border: {},
                borderRadius: "0px",
                _meta: {
                  htmlID: `u_column_${Date.now()}`, // Unique HTML ID
                  htmlClassNames: "u_column"
                }
              }
            }
          ],
          values: {
            displayCondition: null,
            columns: false,
            _styleGuide: null,
            backgroundColor: "",
            columnsBackgroundColor: "",
            backgroundImage: {
              url: "",
              fullWidth: true,
              repeat: "no-repeat",
              size: "custom",
              position: "center",
              customPosition: ["50%", "50%"]
            },
            padding: "0px",
            anchor: "",
            hideDesktop: false,
            _meta: {
              htmlID: `u_row_${Date.now()}`, // Unique HTML ID
              htmlClassNames: "u_row"
            },
            selectable: true,
            draggable: true,
            duplicatable: true,
            deletable: true,
            hideable: true
          }
        };

        // Append the new row to the rows array
        design.body.rows.push(newRow);
      } else {
        console.log('i am here');
        // If rows exist, append the placeholder to the last column in the first row
        const firstRow = design.body.rows[0];
        const lastColumn = firstRow.columns[firstRow.columns.length - 1]; // Get the last column

        console.log('firstRow:', firstRow);
        console.log('lastColumn:', lastColumn);

        if (lastColumn.contents && lastColumn.contents.length > 0) {
          // Append the placeholder to the `text` of the last content item in the last column
          const lastContent = lastColumn.contents[lastColumn.contents.length - 1];
          if (lastContent.type === 'text' && lastContent.values && lastContent.values.text) {
            // lastContent.values.text += `<span>${placeholder}</span>`; // Append the placeholder wrapped in <p>
            const currentText = lastContent.values.text.replace(/<\/?p>/g, ''); // Remove any existing <p> tags if present
            lastContent.values.text = `<p>${currentText}<span>${placeholder}</span></p>`; // Append the placeholder inside the <p> tag
          } else {
            // If the last content is not text, add a new text content with the placeholder
            lastColumn.contents.push({
              type: 'text',
              values: {
                text: `<span>${placeholder}</span>`
              }
            });
          }
        } else {
          // If the last column has no contents, initialize it with the placeholder
          lastColumn.contents = [
            {
              type: 'text',
              values: {
                text: `<span>${placeholder}</span>`
              }
            }
          ];
        }
      }


      console.log('Modified Design:', design);

      this.emailEditor.editor.loadDesign(
        JSON.parse(JSON.stringify(design ? design : ''))
      );
    });
  }

  // called when the editor is created
  editorLoaded() {
  }



  // called when the editor has finished loading
  editorReady() {

    setTimeout(() => {
      if (this.type === 'edit') {

        try {
          this.emailEditor.editor.loadDesign(
            JSON.parse(this.templateDataToEdit.template_design)
          );
          // ✅ TRACKING: Template design loaded
          this.tracker.track(
            'Load',
            'Email Template Editor',
            `Loaded design for template: ${this.templateDataToEdit?.template_name || 'Unnamed'}`
          );
        } catch (error) {
          console.error('Error loading design:', error);
        }
      }
    }, 500);
  }

  async exportHtml(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.emailEditor.editor.exportHtml((data: any) => {
        if (data && data.html) {
          console.log('Exported HTML:', data.design);
          this.htmlData = data.html;
          this.design = data.design;
          resolve(); // Resolve the promise once data is available
        } else {
          reject('Error exporting HTML');
        }
      });
    });
  }


  async onSubmit(form: any) {
    if (form.valid) {
      try {
        this.btnLoading = true;
        await this.exportHtml();

        const payload = {
          client_id: this.LocalStorage.getClientId(),
          template_body: this.htmlData,
          template_name: this.formData.templateName,
          template_category: this.formData.templateCategory,
          template_design: JSON.stringify(this.design),
          status: this.formData.status
        }

        if (this.type === 'edit') {

          const payload2 = {
            client_id: this.LocalStorage.getClientId(),
            template_id: this.templateDataToEdit.template_id,
            template_body: this.htmlData,
            template_design: JSON.stringify(this.design),
            template_name: this.formData.templateName,
            template_category: this.formData.templateCategory,
            status: this.formData.status
          }

          this.api.updateTemplate(payload2).subscribe(
            (res: any) => {
              // ✅ TRACKING: Template updated
              this.tracker.track(
                'Update',
                'Email Template',
                `Updated template: ${this.formData.templateName}`
              );
              this.reload.emit();
            },
            (error: any) => {
              console.log('Error:', error);
              this.btnLoading = false;
              this.toast.error('Error updating template');
            }
          );
        } else {
          this.api.createTemplate(payload).subscribe(
            (res: any) => {
              // ✅ TRACKING: Template created
              this.tracker.track(
                'Create',
                'Email Template',
                `Created template: ${this.formData.templateName}`
              );
              console.log('Response:', res);
              this.reload.emit();
            },
            (error: any) => {
              console.log('Error:', error);
              this.btnLoading = false;
              this.toast.error('Error creating template');
            }
          );
        }

      } catch (e) {
        console.log('Error:', e);
        this.btnLoading = false;
        this.toast.error('Error creating template');
      }

    } else {
      // If form is invalid, mark all fields as touched to show validation errors
      Object.keys(form.controls).forEach(field => {
        const control = form.controls[field];
        control.markAsTouched({ onlySelf: true });
      });
    }
  }

  closeModal2() {
    this.modalService.dismissAll();
  }

  onEditorChange() {
    // Handle CKEditor data change
  }

  onFileSelected(event: any) {
    const selectedFiles: FileList = event.target.files;
    console.log('Selected Files:', selectedFiles);
    for (let i = 0; i < selectedFiles.length; i++) {
      const file = selectedFiles[i];
      const reader = new FileReader();
      console.log('File:', file);
      reader.onload = (e: any) => {
        this.files.push({ file, preview: e.target.result });
        console.log('Files:', this.files);
      };

      reader.readAsDataURL(file);  // Generate preview
    }
  }

  formatSize(size: number): string {
    if (size < 1024) return `${size} B`;
    else if (size < 1048576) return `${(size / 1024).toFixed(2)} KB`;
    else return `${(size / 1048576).toFixed(2)} MB`;
  }

  // Remove a File from the List
  removeFile(index: number) {
    this.files.splice(index, 1);
  }

  onTemplateChange(event: any) {
    console.log('Selected Template:', event.target.value);
  }

  processAction(content: any) {

    if (this.emailSubject === '') {
      this.toast.error('Please enter email subject');
      return;
    }
    // ✅ TRACKING: Task creation initiated
    this.tracker.track(
      'Prepare',
      'Sequence Task',
      `User started creating task using ${this.templateSelection === 'custom' ? 'custom content' : 'template ID ' + this.selectedTemplate}`
    );


    if (this.templateSelection === 'custom') {
      console.log('Custom Email Content:', this.editorData);
      if (this.editorData === '') {
        this.toast.error('Please enter email content');
        return;
      }
    } else {
      if (this.selectedTemplate === null) {
        this.toast.error('Please select a template');
        return;
      }
    }

    // this.btnLoading = true;
    // // Simulate a process or API call
    // setTimeout(() => {
    //   this.btnLoading = false;
    //   console.log('Action processed');
    // }, 2000);

    if (this.templateSelection !== 'custom') {
      console.log('Selected Template:', this.selectedTemplate);
      this.handleGetEmailTemplateById(this.selectedTemplate);
    }


    this.modalService
      .open(content, {
        size: 'md', scrollable: true, centered: true,
        backdrop: 'static', keyboard: false
      })
  }

  processUpdateAction(content: any) {

    if (this.new_subject === '') {
      this.toast.error('Please enter email subject');
      return;
    }
    // ✅ TRACKING: Task update preparation
    this.tracker.track(
      'Prepare Update',
      'Sequence Task',
      `User started updating task ID: ${this.taskToEdit?.id || 'N/A'} using ${this.templateSelection === 'custom' ? 'custom content' : 'template ID ' + this.selectedTemplate}`
    );
    if (this.templateSelection === 'custom') {
      console.log('Custom Email Content:', this.editorData);
      if (this.editorData === '') {
        this.toast.error('Please enter email content');
        return;
      }
    } else {
      if (this.selectedTemplate === null) {
        this.toast.error('Please select a template');
        return;
      }
    }

    // this.btnLoading = true;
    // // Simulate a process or API call
    // setTimeout(() => {
    //   this.btnLoading = false;
    //   console.log('Action processed');
    // }, 2000);

    if (this.templateSelection !== 'custom') {
      console.log('Selected Template:', this.selectedTemplate);
      this.handleGetEmailTemplateById(this.selectedTemplate);
    }


    this.modalService
      .open(content, {
        size: 'md', scrollable: true, centered: true,
        backdrop: 'static', keyboard: false
      })
  }

  handleGetEmailTemplateById(id: any) {
    this.isFetchingTemplates = true;
    const payload = {
      "client_id": this.LocalStorage.getClientId(),
      "template_id": id
    }
    this.api3.getEmailTemplateById(payload).subscribe(
      (res: any) => {
        let updatedBody = res.template_body
        for (const key in this.communicationData) {
          if (this.communicationData.hasOwnProperty(key)) {
            const value = this.communicationData[key];
            // Replace the placeholder (e.g., {{contact_name}}) with the corresponding value
            const placeholder = `{{${key}}}`;
            const regex = new RegExp(placeholder, 'g');
            updatedBody = updatedBody.replace(regex, value);
          }
        }
        this.templateDataToSend = updatedBody;
        this.sanitizedData = this.sanitizer.bypassSecurityTrustHtml(updatedBody);

        console.log('sanitizedData Data 123:', this.sanitizedData);

        this.isFetchingTemplates = false
        // ✅ TRACKING: Template populated
        this.tracker.track(
          'Load',
          'Email Template',
          `Fetched and populated template ID: ${id} for preview`
        );
      },
      (error: any) => {
        this.isFetchingTemplates = false
        console.error('Error creating campaign', error);

      }

    );
  }

  Submit() {

    this.btnLoading2 = true;

    const seqEmailProvider = String(
      this.currentSequence?.email_provider_type || this.LocalStorage.getEmailProviderTypeForPayload()
    ).toUpperCase();

    let today_date = moment().tz('Asia/Kolkata').format('YYYY-MM-DD');

    // if (this.dataSource && this.dataSource.data && this.dataSource.data.length > 0) {

    //   let lastElement: any = this.dataSource.data.slice(-1);
    //   console.log("las elent : ", lastElement);

    //   // chceking current schedule date and time must be greater than last element date and time
    //   let lastSchedule = moment.tz(lastElement[0]["schedule_date"] + ' ' + lastElement[0]["schedule_time"], 'YYYY-MM-DD HH:mm', 'Asia/Kolkata');
    //   let currentSchedule = moment.tz(this.scheduledDate + ' ' + this.scheduledTime, 'YYYY-MM-DD HH:mm', 'Asia/Kolkata');

    //   if (currentSchedule.isBefore(lastSchedule)) {
    //     this.toast.error('Scheduled date and time must be after the last task\'s scheduled time.');
    //     this.btnLoading2 = false;
    //     return;
    //   }
    // }

    let param = {};
    if (this.templateSelection === 'custom') {
      let attachments: any[] = [];

      this.files.forEach((file) => {
        attachments.push({
          "@odata.type": "#microsoft.graph.fileAttachment",
          "name": file.file.name,
          "contentType": file.file.type,
          "contentBytes": file.preview
        });
      });

      param = {
        name: this.stepName,
        client_id: this.LocalStorage.getClientId(),
        sequence_id: this.sequence_id,
        sequence_name: this.currentSequence["name"],
        date: today_date,
        status: false,
        schedule_type: this.taskType,
        automatic_schedule: this.schedule_immediately,
        schedule_date: this.scheduledDate,
        schedule_time: this.scheduledTime,
        complete: false,
        email_template: {
          type: this.templateSelection,
          temp_id: null,
          subject: this.emailSubject,
          contentType: 'HTML',
          bodyContent: this.editorData,
          recipientEmails: this.emails?.length > 0 ? this.emails : [this.communicationData?.contact_email],
          fromEmail: this.LocalStorage.getEmail(),
          ccRecipients: [],
          attachments: attachments,
          emailProviderType: seqEmailProvider,
        }
      }
      console.log("paraamamam : ", param)
    }
    else {
      param = {
        name: this.stepName,
        client_id: this.LocalStorage.getClientId(),
        sequence_id: this.sequence_id,
        sequence_name: this.currentSequence["name"],
        date: today_date,
        status: false,
        schedule_type: this.taskType,
        automatic_schedule: this.schedule_immediately,
        schedule_date: this.scheduledDate,
        schedule_time: this.scheduledTime,
        complete: false,
        email_template: {
          type: this.templateSelection,
          temp_id: this.selectedTemplate,
          subject: this.emailSubject,
          contentType: 'HTML',
          bodyContent: this.templateDataToSend,
          recipientEmails: [this.communicationData?.contact_email],
          fromEmail: this.LocalStorage.getEmail(),
          ccRecipients: [],
          attachments: [],
          emailProviderType: seqEmailProvider,
        }
      }
      console.log("paraamamam : ", param)
    }
    if (param) {
      this.sequenceApi.createSequenceTask(param).subscribe({
        next: (res) => {
          this.toast.success('Email sent successfully');
          this.btnLoading2 = false;
          this.modalService.dismissAll();
          // ✅ TRACKING: Task created
          this.tracker.track(
            'Create',
            'Sequence Task',
            `Created sequence task: ${this.stepName} for sequence ${this.currentSequence?.name}`
          );

          console.log("currr seq ", this.currentSequence);
          // localStorage.setItem('sequence_selected', JSON.stringify(res));
          // this.currentSequence = JSON.parse(localStorage.getItem('sequence_selected') || "");
          // this.paused = this.currentSequence.paused;
          // this.active = this.currentSequence.active;
          // console.log("cur seq : ",this.currentSequence);
          // localStorage.setItem('sequence_selected',JSON.stringify(this.currentSequence));
          this.loadData();
          this.resetForm();
          // this.closeModal2();
          // this.modalService
          //   .open(this.content1, {
          //     size: 'lg', scrollable: true, centered: true,
          //     backdrop: 'static', keyboard: false
          //   })
        },
        error: (e: any) => {
          console.log(e);
          this.toast.error('Error sending email');
          this.btnLoading2 = false;
          this.modalService.dismissAll();
        }
      })
    }
    else {
      this.btnLoading2 = false;
    }
  }

  resetForm() {
    this.stepName = '';
    this.emailSubject = '';
    this.editorData = '';
    this.files = [];
    this.templateSelection = 'custom';
    this.selectedTemplate = null;
    this.emails = [];
    this.schedule_immediately = false;
    this.scheduledDate = '';
    this.scheduledTime = '';
  }

  UpdateEmail() {
    this.btnLoading2 = true;

    const seqEmailProvider = String(
      this.currentSequence?.email_provider_type || this.LocalStorage.getEmailProviderTypeForPayload()
    ).toUpperCase();

    let param = {};
    if (this.templateSelection === 'custom') {
      let attachments: any[] = [];

      this.files.forEach((file) => {
        attachments.push({
          "@odata.type": "#microsoft.graph.fileAttachment",
          "name": file.file.name,
          "contentType": file.file.type,
          "contentBytes": file.preview
        });
      });

      param = {
        id: this.taskToEdit.id,
        name: this.new_stepName,
        client_id: this.LocalStorage.getClientId(),
        sequence_id: this.sequence_id,
        schedule_date: this.new_schedule_date,
        schedule_time: this.new_schedule_time,
        automatic_schedule: this.new_automatic_schedule,
        email_template: {
          subject: this.new_subject,
          contentType: 'HTML',
          bodyContent: this.editorData,
          recipientEmails: this.emails?.length > 0 ? this.emails : [this.communicationData?.contact_email],
          fromEmail: this.LocalStorage.getEmail(),
          ccRecipients: [],
          attachments: attachments,
          type: this.templateSelection,
          emailProviderType: seqEmailProvider,
        }
      }
      console.log("paraamamam : ", param)
    }
    else {
      param = {
        id: this.taskToEdit.id,
        name: this.new_stepName,
        client_id: this.LocalStorage.getClientId(),
        sequence_id: this.sequence_id,
        schedule_date: this.new_schedule_date,
        schedule_time: this.new_schedule_time,
        automatic_schedule: this.new_automatic_schedule,
        email_template: {
          subject: this.new_subject,
          contentType: 'HTML',
          bodyContent: this.templateDataToSend,
          recipientEmails: [this.communicationData?.contact_email],
          fromEmail: this.LocalStorage.getEmail(),
          ccRecipients: [],
          attachments: [],
          type: this.templateSelection,
          temp_id: this.selectedTemplate,
          emailProviderType: seqEmailProvider,
        }
      }
      console.log("paraamamam : ", param)
    }
    if (param) {
      this.sequenceApi.updateSequenceTask(param).subscribe({
        next: (res) => {
          this.toast.success('Email sent successfully');
          this.btnLoading2 = false;
          this.modalService.dismissAll();
          this.editorData = "";
          console.log("currr seq ", this.currentSequence);
          // ✅ TRACKING: Task updated
          this.tracker.track(
            'Update',
            'Sequence Task',
            `Updated task ID: ${this.taskToEdit?.id} (${this.new_stepName}) in sequence ${this.currentSequence?.name}`
          );
          // localStorage.setItem('sequence_selected', JSON.stringify(res));
          // this.currentSequence = JSON.parse(localStorage.getItem('sequence_selected') || "");
          // this.paused = this.currentSequence.paused;
          // this.active = this.currentSequence.active;
          // console.log("cur seq : ",this.currentSequence);
          // localStorage.setItem('sequence_selected',JSON.stringify(this.currentSequence));
          this.loadData();
          // this.closeModal2();
          // this.modalService
          //   .open(this.content1, {
          //     size: 'lg', scrollable: true, centered: true,
          //     backdrop: 'static', keyboard: false
          //   })
        },
        error: (e: any) => {
          console.log(e);
          this.toast.error('Error sending email');
          this.btnLoading2 = false;
          this.editorData = "";
          this.modalService.dismissAll();
        }
      })
    }
    else {
      this.btnLoading2 = false;
    }
  }

  loadEmailTemplate() {
    const payload = {
      client_id: this.LocalStorage.getClientId(),
    }

    this.api3.getAllEmailTemplates(payload).subscribe({
      next: (res) => {
        this.templates = res

      },
      error: (e: any) => {
        console.log(e);
      }
    })

  }

  continueTemplate(content: any) {
    this.isLoading = false;
    // console.log("task type, name, immediatly", this.taskType, this.stepName, this.schedule_immediately);
    console.log("time : ", this.time_unit, this.time_type);
    this.loadEmailTemplate();

    // check Previous step scheduled date and time must be less than current date and time
    if (this.dataSource && this.dataSource.data && this.dataSource.data.length > 0) {

      let lastElement: any = this.dataSource.data.slice(-1);
      console.log("las elent : ", lastElement);

      // chceking current schedule date and time must be greater than last element date and time
      let lastSchedule = moment.tz(lastElement[0]["schedule_date"] + ' ' + lastElement[0]["schedule_time"], 'YYYY-MM-DD HH:mm', 'Asia/Kolkata');
      let currentSchedule = moment.tz(this.scheduledDate + ' ' + this.scheduledTime, 'YYYY-MM-DD HH:mm', 'Asia/Kolkata');

      if (currentSchedule.isBefore(lastSchedule)) {
        this.toast.error(
          "Scheduled date and time must be after the last task's scheduled time, which is " + lastSchedule.format("YYYY-MM-DD HH:mm"),
          "Error",
          {
            timeOut: 20000,          // ⏱ show for 20s (default is 5s)
            extendedTimeOut: 5000,   // ⏱ if hovered, extra 5s
            positionClass: "toast-top-right", // 📍 top-right position
            closeButton: true,       // ❌ show close button
            tapToDismiss: false      // 👆 don't dismiss on click
          }
        );
        this.btnLoading2 = false;
        return;
      }
    }


    this.modalService.open(content, {
      size: 'xl',
      scrollable: true,
      centered: true
    })
  }

  calculateISTFutureDate(
    value: number,
    unit: string,
    inputDate?: string,
    inputTime?: string
  ): { date: string, time: string } {
    if (isNaN(value) || value < 0) {
      throw new Error('Invalid input: value must be a non-negative number');
    }

    let time;

    if (inputDate && inputTime) {
      const dateTimeStr = `${inputDate} ${inputTime}`;
      time = moment.tz(dateTimeStr, 'YYYY-MM-DD HH:mm', 'Asia/Kolkata');

      if (!time.isValid()) {
        throw new Error('Invalid input: Combined date and time is not valid');
      }
    } else {
      // Default to current IST time
      time = moment().tz('Asia/Kolkata');
    }

    // Add value based on unit
    if (unit === 'minutes') {
      time = time.add(value, 'minutes');
    } else if (unit === 'hours') {
      time = time.add(value, 'hours');
    } else {
      throw new Error('Invalid unit: must be "minutes" or "hours"');
    }

    const date = time.format('YYYY-MM-DD');
    const formattedTime = time.format('HH:mm'); // 24-hour format

    return { date, time: formattedTime };
  }




  disableTimeIo() {

  }

  toggleSequenceDetail() {
    this.mobileSequenceFilter = !this.mobileSequenceFilter;
  }
  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    if (window.innerWidth > 768 && this.mobileSequenceFilter) {
      this.mobileSequenceFilter = false;
    }
  }

  deleteStep(content: any, element: any) {
    this.taskToEdit = element;
    this.modalService.open(content, {
      size: 'md',
      scrollable: true,
      centered: true
    })
  }

  deleteSequenceTaskBE() {

    const payload = {
      id: this.taskToEdit.id,
      client_id: this.LocalStorage.getClientId(),
      sequence_id: this.sequence_id
    }
    this.deleteLoading = true;
    this.sequenceApi.deleteSequenceTask(payload).subscribe({
      next: (res) => {
        this.toast.success('Task deleted successfully');
        this.modalService.dismissAll();
        // ✅ TRACKING: Task deleted
        this.tracker.track(
          'Delete',
          'Sequence Task',
          `Deleted task ID: ${this.taskToEdit?.id} (${this.taskToEdit?.name}) from sequence ${this.currentSequence?.name}`
        );
        this.loadData();
        this.deleteLoading = false;
      },
      error: (e: any) => {
        console.log(e);
        this.toast.error('Error deleting task');
        this.modalService.dismissAll();
        this.deleteLoading = false;
      }
    })
  }


}

export class Sequence {
  id!: Number;
  name: string = "";
  schedule: any = {};
  date: any = "";
}